module.exports = __webpack_public_path__ + "static/bleak-house-369f9f166c3587d329280608c2622d79.jpg";